import { FunctionFactory } from "survey-core";
import { isNullOrUndefined } from "./utils";
import { loc } from "../i18n/survey";

const nameQuestion = {
  name: "name",
  title: loc("quiz.name.title"),
  description: loc("quiz.name.description"),
  type: "text",
  goNextPageAutomatic: false,
  placeholder: loc("quiz.name.placeholder"),
  isRequired: true,
  validators: [
    {
      type: "text",
      minLength: 2,
      text: loc("quiz.name.minLengthError"),
    },
  ],
};

function firstName(params: any[]) {
  if (
    isNullOrUndefined(params) || params.length === 0 ||
    isNullOrUndefined(params[0])
  ) return null;
  return params[0].toString().split(" ")[0];
}

function lastName(params: any[]) {
  if (
    isNullOrUndefined(params) || params.length === 0 ||
    isNullOrUndefined(params[1])
  ) return null;
  return params[0].split(" ")[1];
}

const firstNameExpression = {
  name: "firstname",
  expression: "firstName({name})",
};

const lastNameExpression = {
  name: "lastname",
  expression: "lastName({name})",
};

FunctionFactory.Instance.register("firstName", firstName);
FunctionFactory.Instance.register("lastName", lastName);

export {
  firstName,
  firstNameExpression,
  lastName,
  lastNameExpression,
  nameQuestion,
};

